import { defineStore } from 'pinia'

export interface Announcement {
  date: string
  type: string
  message: string
  link: string | null
}

const ANNOUNCEMENTS_URL = 'https://the-odds-api.com/announcements.json'
const LAST_SEEN_KEY = 'announcements-last-seen'

export const announcementsStore = defineStore({
  id: 'announcements',
  state: () => ({
    announcements: [] as Announcement[],
    loaded: false as boolean,
    lastSeen: localStorage.getItem(LAST_SEEN_KEY) || '',
  }),
  getters: {
    unreadCount: (state) => {
      return state.announcements.filter(a => a.date > state.lastSeen).length
    },
  },
  actions: {
    async fetchAnnouncements() {
      if (this.loaded) {
        return
      }
      try {
        const response = await fetch(ANNOUNCEMENTS_URL)
        this.announcements = await response.json()
      } catch (error) {
        this.announcements = []
      } finally {
        this.loaded = true
      }
    },
    markAllSeen() {
      const latest = this.announcements.reduce((max, a) => a.date > max ? a.date : max, this.lastSeen)
      this.lastSeen = latest
      localStorage.setItem(LAST_SEEN_KEY, latest)
    },
  },
})
